import { ToastViewport } from '@vgw/multibrand-fe-toast'
import { useInitUserInactivityManager } from './features/user-inactivity-manager/use-init-user-inactivity-manager'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { Page404 } from './routes/-404/404'
import { initializeGrafanaIntegration } from '@/grafana-integration'

const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultNotFoundComponent: Page404,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface HistoryState {
    from?: string
  }
}

void initializeGrafanaIntegration(router)

export const App = () => {
  useInitUserInactivityManager({ router })

  return (
    <>
      <ToastViewport className="fixed top-16 left-1/2 z-9999 w-full -translate-x-1/2" />
      <RouterProvider router={router} />
    </>
  )
}
